(() => {
  const helper = window.SHTHelper || (window.SHTHelper = {});
  if (typeof helper.forceUpdateCartStatus === 'function') return;

  helper.forceUpdateCartStatus = () => {
    const root = window.Shopify?.routes?.root || '/';
    fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Cart refresh failed (${response.status})`);
        return response.json();
      })
      .then((cart) => {
        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'pagefly-product',
              data: { itemCount: cart.item_count, source: 'pagefly-product' },
            },
          })
        );
      })
      .catch((error) => console.warn('[BSA cart refresh]', error));
  };
})();
